// Shared constants used by web, mobile, and server

export const getDateKey = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

export const DAY_ABBREVIATIONS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type DayAbbreviation = typeof DAY_ABBREVIATIONS[number];
